





import { defineComponent, reactive } from "@vue/composition-api";
import router from "@/router";
import queryString from "query-string";
import Loading from "@/components/Loading.vue";
import {
  googleSsoRequest,
  msSsoRequest,
  ssoLoginGoogle,
  ssoLoginMS,
} from "@/data/repos/ssoLogin";
import { setKV } from "@/modules/browserLocalStorage";
import { CLIENT_COOKIE_NAME } from "@/interfaces/common.interfaces";
import { getDayEnd, SaveAuth } from "@/modules/auth";
import { Auth } from "@micad/vue-components/src/repos/login";
import { LoginResponse } from "@/data/repos/passwordLogin";
import { displayRequestStatus } from "@/notifications";

export default defineComponent({
  components: { Loading },
  setup() {
    const next = async (r: LoginResponse, ourState: any) => {
      SaveAuth({
        userId: r.userId,
        sessionId: r.sessionId,
        expiry: getDayEnd().toISOString(),
      } as Auth);
      await router.push({
        name: "chooseClient",
        query: ourState,
        params: {
          session: JSON.stringify(r),
          clientKey: ourState.clientKey as string,
        },
      });
    };
    try {
      const callbackQuery = router.currentRoute.fullPath.split("#")[1];
      const callbackParsed = queryString.parse(callbackQuery);
      const ourState = queryString.parse(
        (callbackParsed.state as string) || "{}"
      );
      if (
        callbackParsed.scope &&
        String(callbackParsed.scope).includes(
          " https://www.googleapis.com/auth/userinfo.email"
        )
      ) {
        ssoLoginGoogle(
          callbackParsed as googleSsoRequest,
          ourState.clientKey || undefined,
          ((ourState.app || "") as string) || undefined
        ).then(async (response) => {
          displayRequestStatus(
            response,
            "",
            "Sign in with Google is currently unavailable"
          );
          if (response.ok && response.payload) {
            const r = response.payload;
            if (r.clientKey) setKV(CLIENT_COOKIE_NAME, r.clientKey);
            await next(r, ourState);
          } else {
            setTimeout(() => router.push("/"), 3000);
          }
        });
      } else {
        ssoLoginMS(
          callbackParsed as msSsoRequest,
          ourState.clientKey || undefined,
          ((ourState.app || "") as string) || undefined
        ).then(async (response) => {
          displayRequestStatus(
            response,
            "",
            "Sign in with Microsoft is currently unavailable"
          );
          if (response.ok && response.payload) {
            const r = response.payload;
            if (r.clientKey) setKV(CLIENT_COOKIE_NAME, r.clientKey);
            await next(r, ourState);
          } else {
            setTimeout(() => router.push("/"), 3000);
          }
        });
      }
    } catch {
      console.error("wrong callback");
      router.push("/");
    }
  },
});
